import { render, staticRenderFns } from "./EpsBlockedAttachmentTypes.vue?vue&type=template&id=7908ba40&"
import script from "./EpsBlockedAttachmentTypes.vue?vue&type=script&lang=js&"
export * from "./EpsBlockedAttachmentTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports